import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { ErrorText } from '@/components/ui';
import { UserProfileView } from '@/components/user-profile';

/** Any person on the platform, for Nirvik's admins: everything they've done. */
export function AdminUserProfilePage() {
  const { userId = '' } = useParams();
  const api = useApi();
  const profile = useQuery({
    queryKey: ['admin', 'userProfile', userId],
    queryFn: () => api.admin.userProfile(userId),
  });
  if (profile.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (profile.isError) return <ErrorText error={profile.error} />;
  return (
    <UserProfileView
      profile={profile.data}
      back={{ to: '/admin/users', label: 'Users' }}
      scopeNote="Everything across Nirvik Ready: all organizations, Nirvik's public courses and quizzes, and private certificates."
    />
  );
}
